/** Month helpers shared by the organization and platform cost pages. */

/** "YYYY-MM" for the month a date falls in, in local time. */
export function monthOf(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}

/** The half-open ISO date range one "YYYY-MM" covers. */
export function monthRange(month: string): { start: string; end: string } {
  const [year, m] = month.split('-').map(Number) as [number, number];
  const next = m === 12 ? `${year + 1}-01` : `${year}-${String(m + 1).padStart(2, '0')}`;
  return { start: `${month}-01`, end: `${next}-01` };
}

/** The same range as instants, for routes that filter on a timestamp. */
export function monthInstants(month: string): { start: string; end: string } {
  const { start, end } = monthRange(month);
  return { start: `${start}T00:00:00+00:00`, end: `${end}T00:00:00+00:00` };
}
